module.exports = __webpack_public_path__ + "img/logo.ec1b8467.svg";